import React from 'react';

import { CONTROL_SELECT_CLASS_NAME } from './RoadmapPeriodSelect';

import { formatDateLong } from 'Helpers/dateFormat';

import SegmentedControl from 'CommonComponents/SegmentedControl';

const modeOptions = () => [
    { value: 'off', label: $t('Off') },
    { value: 'critical', label: $t('Critical') },
    { value: 'near', label: $t('Critical + near-critical') },
];

/** "Gates open · 31 Mar 2026", or the description alone when the milestone has no date. */
const targetLabel = (milestone) => (milestone.date ? `${milestone.description} · ${formatDateLong(milestone.date)}` : milestone.description);

/**
 * The Critical path mode, and while it is on, the key milestone the floats are measured to. Every
 * key milestone in the event can be the target, whatever the source and category filters.
 */
const RoadmapCriticalPathControl = ({ mode, target, schedule, onChange }) => {
    const keyMilestones = schedule?.key_milestones || [];
    // The saved target shows straight away while its refetch is in flight; a stale one falls back to the resolved target.
    const selected = keyMilestones.some((milestone) => milestone.id === target) ? target : schedule?.target_id;

    return (
        <>
            <div className="tw-flex tw-flex-col tw-flex-shrink">
                <span className="inbud-control-label">{$t('Critical path')}</span>
                <SegmentedControl variant="track" options={modeOptions()} value={mode} onChange={(criticalPath) => onChange({ criticalPath })} />
            </div>

            {mode !== 'off' && (
                <div className="tw-flex tw-flex-col tw-min-w-[180px] tw-max-w-[320px]">
                    <label htmlFor="roadmap-critical-target" className="inbud-control-label">
                        {$t('Target')}
                    </label>
                    <select
                        id="roadmap-critical-target"
                        name="roadmap-critical-target"
                        className={CONTROL_SELECT_CLASS_NAME}
                        value={selected ?? ''}
                        disabled={!keyMilestones.length}
                        onChange={(event) => onChange({ criticalTarget: Number(event.target.value) })}
                    >
                        {keyMilestones.length ? (
                            keyMilestones.map((milestone) => (
                                <option key={milestone.id} value={milestone.id}>
                                    {targetLabel(milestone)}
                                </option>
                            ))
                        ) : (
                            <option value="">{schedule ? $t('No key milestones') : $t('Loading…')}</option>
                        )}
                    </select>
                </div>
            )}
        </>
    );
};

export default RoadmapCriticalPathControl;
